<template>
  <div class="page full" id="index">
    <div class="page02">
      <div class="header">
        <div class="logo-bar">
          <img src="@/assets/logo-100.png" />
          <img src="@/assets/honor.png"  @click="routerJump('/glory')"/>
        </div>
        <div class="index-img-bar">
          <div class="index-img">
            <img src="@/assets/index-head.png" />
          </div>
          <img src="@/assets/cloud.png" class="cloud" />
        </div>
      </div>
      <div class="rule-btn" @click="showPopup">活动规则</div>
      <img class="btn-dt" src="@/assets/btn-index.png" @click="toGame" />

      <!-- 底部图片 -->
      <!-- <div class="bottom-txt">
        <img src="@/assets/bottom-img_02.png" />
      </div> -->
      <!-- 活动规则弹窗 -->
      <van-popup v-model="show" closeable round>
        <div class="rule-mod-wrap">
          <div class="rule-mod">
            <div class="rule-tit">
              <img src="@/assets/rule-tit.png" />
            </div>
            <p>1. 活动期间，每完成一次打卡且答题全部正确，即为完成当次打卡，获得一次亲子“点亮星星”的机会；</p>
            <p>2. 每次打卡，第一轮答题错误，可以点击“再来一次”继续答题，直到答对为止，即为完成当次打卡，获得一次亲子“点亮星星”的机会；</p>
            <p>3. 答题过程，中途退出页面，再次进入则重新开始答题。</p>
            <p>4. 完成5次的打卡任务，点亮5颗小星星后获得“升旗手”个人荣誉证书。</p>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import index from "./index.js";

export default {
  ...index
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
